import { useAppDispatch, useAppSelector } from "../../lib/redux/hooks";
import { MadfarmInput } from "../../ui/molecules/input/newInput";
import { MadfarmStaticSelect } from "../../ui/molecules/select/newSelect/static";
import { requisiti_certificazione, residuo_zero_type, tipologia_residuo_zero } from "../../utils";
import { setCustomerCreateRequestField, setCustomerUpdateRequestField } from "../clienti/feature/slice";

interface Props {
  mode?: "create" | "edit"
}

export function ResiduoZero({ mode }: Props) {
  const customerState = useAppSelector((state) => state.customer);
  const dispatch = useAppDispatch();

  // useEffect(() => {
  //   if (customerState.getCustomerByIdResponse !== undefined) {
  //     dispatch(setResiduoZeroType(customerState.getCustomerByIdResponse.zrCertificationType));
  //     dispatch(setPercResiduoContr(customerState.getCustomerByIdResponse.zrTargetThreshold))
  //     dispatch(setResiduoZeroReqAgg(customerState.getCustomerByIdResponse.zrAddingRequirements))
  //     dispatch(setResiduoZeroTypology(customerState.getCustomerByIdResponse.zrType))
  //   }
  // }, [customerState.getCustomerByIdResponse]);

  const clienteEditCreateRequest = mode === "create" ? customerState.customerCreateRequest : customerState.customerUpdateRequest

  return (
    <div className="flex flex-col gap-4 border-t border-neutral-200 pt-6">
      <MadfarmStaticSelect
        label="Tipo di certificazione"
        noOptionsMessage="Nessun tipo di certificazione trovato"
        placeholder="Tipo certificazione"
        defaultValue={clienteEditCreateRequest.zrCertificationType}
        value={clienteEditCreateRequest.zrCertificationType}
        options={residuo_zero_type}
        onChange={(value) => {
          //@ts-ignore
          const newValue = value !== null ? value.value : null
          if (mode === "create")
            dispatch(setCustomerCreateRequestField({ field: "zrCertificationType", value: newValue }))
          else
            dispatch(setCustomerUpdateRequestField({ field: "zrCertificationType", value: newValue }))
        }}
      />
      {
        clienteEditCreateRequest.zrCertificationType === "RESIDUO_CONTROLLATO" &&
        <MadfarmInput
          label="Soglia Target minima ≤ al 50% rispetto al LMR di legge"
          onChangeText={(value) => {
            if (mode === "create")
              dispatch(setCustomerCreateRequestField({ field: "zrTargetThreshold", value: value }))
            else
              dispatch(setCustomerUpdateRequestField({ field: "zrTargetThreshold", value: value }))
          }}
          value={clienteEditCreateRequest.zrTargetThreshold?.toString()}
          placeholder="Specificare la percentuale (%)"
        />
      }
      <MadfarmStaticSelect
        noOptionsMessage="Nessun requisito trovato"
        label="Requisito aggiuntivo"
        placeholder="Requisito aggiuntivo"
        defaultValue={clienteEditCreateRequest.zrAddingRequirements}
        value={clienteEditCreateRequest.zrAddingRequirements}
        options={requisiti_certificazione}
        onChange={(value) => {
          //@ts-ignore
          const newValue = value !== null ? value.value : null
          if (mode === "create")
            dispatch(setCustomerCreateRequestField({ field: "zrAddingRequirements", value: newValue }))
          else
            dispatch(setCustomerUpdateRequestField({ field: "zrAddingRequirements", value: newValue }))
        }}
      />
      <MadfarmStaticSelect
        noOptionsMessage="Nessuna tipologia trovata"
        label="Tipologia"
        placeholder="Tipologia"
        defaultValue={clienteEditCreateRequest.zrType}
        value={clienteEditCreateRequest.zrType}
        options={tipologia_residuo_zero}
        onChange={(value) => {
          //@ts-ignore
          const newValue = value !== null ? value.value : null
          if (mode === "create")
            dispatch(setCustomerCreateRequestField({ field: "zrType", value: newValue }))
          else
            dispatch(setCustomerUpdateRequestField({ field: "zrType", value: newValue }))
        }}
      />
    </div>
  );
}
